import { useQuery } from "@apollo/client";
import { Chat as ChatType, Query } from "@/app/graphql/codegen";
import { FETCH_MESSAGES_FOR_CHAT } from "@chat/graphql/queries/fetchMessagesForChat";
import { useDispatch } from "react-redux";
import { reconcilePendingMessages } from "@store/slices/chat";
import { useEffect } from "react";

// Always poll for new messages so updates from other users appear automatically.
// Polling interval is configurable via the third parameter and defaults to 3000 ms.
export const useChatMessages = (
    chatId?: string | null,
    limit?: number,
    pollInterval: number = 3000,
) => {
    const dispatch = useDispatch();
    
    const { data, loading, refetch } = useQuery<Pick<Query, "chat">, Pick<ChatType, "id">>(FETCH_MESSAGES_FOR_CHAT, {
        variables: { id: chatId || "" },
        skip: !chatId,
        pollInterval,
    });

    const messages = data?.chat?.messages || [];

    // Reconcile pending messages with server messages (remove pending ones that now exist on server)
    useEffect(() => {
        if (chatId && messages.length > 0) {
            dispatch(reconcilePendingMessages({
                chatId,
                serverMessages: messages,
            }));
        }
    }, [chatId, messages, dispatch]);

    // Wenn ein Limit gesetzt ist, geben wir nur die letzten n Nachrichten zurück
    const limitedMessages = limit ? messages.slice(-limit) : messages;

    return {
        messages: limitedMessages,
        loading,
        refetch,
    };
};
